var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTivaicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37239 0 0 5.37239 0 12C0 18.6276 5.37239 24 12 24C18.6276 24 24 18.6276 24 12C24 5.37239 18.6276 0 12 0Z",
    fill: "#C90735"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51741 14.4189C5.51741 14.8974 5.12755 15.2872 4.64909 15.2872C4.17062 15.2872 3.78076 14.8974 3.78076 14.4189V10.9486C3.78076 10.4701 4.17062 10.0802 4.64909 10.0802C5.12755 10.0802 5.51741 10.4701 5.51741 10.9486V14.4189Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16791 15.7893C9.16791 16.2678 8.77805 16.6576 8.29959 16.6576C7.82113 16.6576 7.43127 16.2678 7.43127 15.7893V9.48954C7.43127 9.01108 7.82113 8.62122 8.29959 8.62122C8.77805 8.62122 9.16791 9.01108 9.16791 9.48954V15.7893Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5664 15.7893C16.5664 16.2678 16.1765 16.6576 15.6981 16.6576C15.2196 16.6576 14.8297 16.2678 14.8297 15.7893V9.48954C14.8297 9.01108 15.2196 8.62122 15.6981 8.62122C16.1765 8.62122 16.5664 9.01108 16.5664 9.48954V15.7893Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1128 7.06768H12.8214V17.8892C12.8214 18.3677 12.4315 18.7576 11.953 18.7576C11.4746 18.7576 11.0847 18.3677 11.0847 17.8892V7.06768H6.79331C6.28827 7.06768 5.88069 6.6601 5.88069 6.15506C5.88069 5.65001 6.28827 5.24243 6.79331 5.24243H17.1128C17.6178 5.24243 18.0254 5.65001 18.0254 6.15506C18.0254 6.6601 17.6178 7.06768 17.1128 7.06768Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2198 14.4189C20.2198 14.8974 19.83 15.2872 19.3515 15.2872C18.8731 15.2872 18.4832 14.8974 18.4832 14.4189V10.9486C18.4832 10.4701 18.8701 10.0802 19.3515 10.0802C19.8329 10.0802 20.2198 10.4701 20.2198 10.9486V14.4189Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTivaicon);
export default __webpack_public_path__ + "static/media/logo-tiva.icon.c0a7fd7a756c0e0a5324d8bd565749de.svg";
export { ForwardRef as ReactComponent };